import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import TopTextSectionAdminPanel from "./TopTextSectionAdminPanel";
import LatestTableAdminPanel from "./LatestTableAdminPanel";
import JobAdminPanel from "./JobAdminPanel";
import SelectionJobAdminPanel from "./SelectionJobAdminPanel";
import HomepageSingleColumnAdminPanel from "./HomepageSingleColumnAdminPanel";
import AdmitCardAdminPanel from "./AdmitCardAdminPnanel";
import ResultAdminPanel from "./ResultAdminPanel";
import AnswerKeyAdminPanel from "./AnswerKeyAdminPanel";
import SyllabusAdminPanel from "./SyllabusAdminPanel";
import AdmissionAdminPanel from "./AdmissionAdminPanel";
import FooterAdminPanel from "./FooterAdminPanel";
import ContactViewPage from "./ContactViewPage";
import AdminControProtected from "./AdminControProtected";

import DatabaseExportAdminPanel from "./DatabaseExportAdminPanel";
import VisitorLogsDashboard from "./VisitorLogsDashboard";
import FeedbackAdminPanel from "./FeedbackAdminPanel";
import FAQAdminPanel from "./FAQAdminPanel";


import EligibilityAdminPanel from "./EligibilityAdminPanel";
import PublicUserListAdminPanel from "./PublicUserListAdminPanel";



function AdminPanel() {
  const navigate = useNavigate();
  const [selectedPanel, setSelectedPanel] = useState(null);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  // Listen for darkMode changes from Navbar (storage event)
  useEffect(() => {
    // Sync dark mode state from localStorage and apply CSS vars/body class
    const syncDarkMode = () => {
      const isDark = localStorage.getItem('darkMode') === 'true';
      setDarkMode(isDark);
      if (isDark) {
        document.documentElement.style.setProperty('--bg-primary', '#0f172a');
        document.documentElement.style.setProperty('--bg-secondary', '#1a1a2e');
        document.documentElement.style.setProperty('--text-primary', '#f1f5f9');
        document.documentElement.style.setProperty('--text-secondary', '#cbd5e1');
        document.documentElement.style.setProperty('--border-color', 'rgba(255, 255, 255, 0.1)');
        document.documentElement.style.setProperty('--accent-color', '#60a5fa');
        document.body.classList.add('dark-mode');
      } else {
        document.documentElement.style.setProperty('--bg-primary', '#ffffff');
        document.documentElement.style.setProperty('--bg-secondary', '#f8f9fa');
        document.documentElement.style.setProperty('--text-primary', '#1f2937');
        document.documentElement.style.setProperty('--text-secondary', '#475569');
        document.documentElement.style.setProperty('--border-color', 'rgba(0, 0, 0, 0.06)');
        document.documentElement.style.setProperty('--accent-color', '#3b82f6');
        document.body.classList.remove('dark-mode');
      }
    };
    syncDarkMode();
    window.addEventListener('storage', syncDarkMode);
    window.addEventListener('darkModeChanged', syncDarkMode);
    return () => {
      window.removeEventListener('storage', syncDarkMode);
      window.removeEventListener('darkModeChanged', syncDarkMode);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/login", { state: { popupType: "success", popupMessage: "Logged out successfully" }, replace: true });
  };

  if (!token) {
    return (
      <div className="admin-panel-error">❌ No token found! Please login first.</div>
    );
  }

  if (role !== "superadmin") {
    return (
      <div className="admin-panel-error">❌ Access denied! Only Super Admin can access this panel.</div>
    );
  }

  // Sidebar menu items
  const menu = [
    { key: "topText", label: "Top Text Section", component: <TopTextSectionAdminPanel /> },
    { key: "latestTable", label: "Latest Table", component: <LatestTableAdminPanel /> },
    { key: "job", label: "Job Management", component: <JobAdminPanel /> },
    { key: "selectionJob", label: "Selection Job Detail", component: <SelectionJobAdminPanel /> },
    { key: "homepageSingleColumn", label: "Homepage Single Column", component: <HomepageSingleColumnAdminPanel /> },
    { key: "admitCard", label: "Admit Card", component: <AdmitCardAdminPanel /> },
    { key: "result", label: "Result", component: <ResultAdminPanel /> },
    { key: "answerKey", label: "Answer Key", component: <AnswerKeyAdminPanel /> },
    { key: "syllabus", label: "Syllabus", component: <SyllabusAdminPanel /> },
    { key: "admission", label: "Admission", component: <AdmissionAdminPanel /> },
    { key: "footer", label: "Footer Management", component: <FooterAdminPanel /> },
    { key: "contact", label: "Contact Database", component: <ContactViewPage isStandalone /> },
    { key: "feedback", label: "Feedback Submissions", component: <FeedbackAdminPanel /> },
    { key: "faq", label: "FAQ Management", component: <FAQAdminPanel /> },
    { key: "databaseExport", label: "Database Export", component: <DatabaseExportAdminPanel /> },
    { key: "visitorLogs", label: "Visitor Logs", component: <VisitorLogsDashboard darkMode={darkMode} /> },
    { key: "eligibility", label: "Eligibility Management", component: <EligibilityAdminPanel /> },
    { key: "publicUserList", label: "Public User List", component: <PublicUserListAdminPanel /> },
    { key: "adminContro", label: "User Approval (AdminContro)", component: <AdminControProtected /> },
  ];

  return (
    <div className={`admin-panel${darkMode ? " dark-mode" : ""}`}> 
      <div className="admin-panel-topbar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5rem' }}>
          <h2 style={{ margin: 0 }}>Super Admin Panel</h2>
          <button 
            className="theme-toggle" 
            style={{ 
              background: darkMode ? '#0f2561' : '#f3f4f6',
              border: darkMode ? '1px solid #e0e6f0' : '1px solid #232836',
              borderRadius: 6, // square corners
              padding: 4, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              transition: 'border-radius 0.15s',
            }}
            onMouseDown={e => e.currentTarget.style.borderRadius = '50%'}
            onMouseUp={e => e.currentTarget.style.borderRadius = '6px'}
            onMouseLeave={e => e.currentTarget.style.borderRadius = '6px'}
            onClick={() => {
              const newMode = !darkMode;
              setDarkMode(newMode);
              localStorage.setItem('darkMode', newMode ? 'true' : 'false');
              // Apply CSS vars and body class immediately
              if (newMode) {
                document.documentElement.style.setProperty('--bg-primary', '#0f172a');
                document.documentElement.style.setProperty('--bg-secondary', '#1a1a2e');
                document.documentElement.style.setProperty('--text-primary', '#f1f5f9');
                document.documentElement.style.setProperty('--text-secondary', '#cbd5e1');
                document.documentElement.style.setProperty('--border-color', 'rgba(255, 255, 255, 0.1)');
                document.documentElement.style.setProperty('--accent-color', '#60a5fa');
                document.body.classList.add('dark-mode');
              } else {
                document.documentElement.style.setProperty('--bg-primary', '#ffffff');
                document.documentElement.style.setProperty('--bg-secondary', '#f8f9fa');
                document.documentElement.style.setProperty('--text-primary', '#1f2937');
                document.documentElement.style.setProperty('--text-secondary', '#475569');
                document.documentElement.style.setProperty('--border-color', 'rgba(0, 0, 0, 0.06)');
                document.documentElement.style.setProperty('--accent-color', '#3b82f6');
                document.body.classList.remove('dark-mode');
              }
              window.dispatchEvent(new Event('darkModeChanged'));
            }}
            title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {darkMode ? (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: '#e0e6f0' }}>
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
            ) : (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: '#232836' }}>
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
            )}
          </button>
        </div>
        <div className="admin-panel-topbar-actions">
          <button type="button" className="admin-logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </div>
      <div className="admin-panel-main">
        <div className="admin-sidebar">
          <nav>
            {menu.map((item) => (
              <button
                key={item.key}
                className={selectedPanel === item.key ? "selected" : ""}
                onClick={() => setSelectedPanel(item.key)}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="admin-content">
          {selectedPanel ? (
            menu.find((item) => item.key === selectedPanel)?.component
          ) : (
            <div className="admin-panel-placeholder">
              👈 Please select a panel from the menu.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
